// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services-offered-selection .services-offered-section {
  display: flex;
  gap: 25px;
  flex-wrap: wrap;
}
.services-offered-selection .services-offered-section .section {
  width: 100%;
  padding: 50px 0;
  box-sizing: border-box;
  margin: 0 auto;
  background-color: white;
  display: flex;
  flex-flow: wrap;
  gap: 25px;
  justify-content: space-between;
  align-items: flex-start;
  align-content: flex-start;
}
.services-offered-selection .services-offered-section .input-section-label {
  display: inline-flex;
  align-items: flex-start;
  color: #CB186B;
  font-size: 20px;
}
.services-offered-selection .services-offered-section .input-group {
  width: 100%;
  display: flex;
  flex-flow: wrap;
  gap: 15px;
}
.services-offered-selection .services-offered-section .input-group label {
  padding: 5px;
}
.services-offered-selection .services-offered-section .input-group label img {
  width: 23px;
}
.services-offered-selection .services-offered-section .input-group label.parent {
  display: flex;
  width: 48%;
  justify-content: flex-start;
  align-items: flex-start;
}
.services-offered-selection .services-offered-section .input-group label.parent .label-title {
  margin-left: 25px;
  cursor: pointer;
}
@media (max-width: 992px) {
  .services-offered-selection .services-offered-section {
    flex-direction: column;
  }
  .services-offered-selection .services-offered-section .input-group label.parent {
    width: 100%;
  }
}

.section-title-and-error {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.section-title-and-error .title-name {
  width: 100%;
}
.section-title-and-error .error {
  color: #aa004f;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/components/ServicesOfferedSelection/styles.scss","webpack://./src/css/colors.scss"],"names":[],"mappings":"AAGE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAFJ;AAGI;EACE,WAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;AADN;AAGI;EACE,oBAAA;EACA,uBAAA;EACA,cCTI;EDUJ,eAAA;AADN;AAGI;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AADN;AAEM;EACE,YAAA;AAAR;AACQ;EACE,WAAA;AACV;AAEM;EACE,aAAA;EACA,UAAA;EACA,2BAAA;EACA,uBAAA;AAAR;AACQ;EACE,iBAAA;EACA,eAAA;AACV;AAIE;EACE;IACE,sBAAA;EAFJ;EAIM;IACE,WAAA;EAFR;AACF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AALF;AAME;EACE,WAAA;AAJJ;AAME;EACE,cCjEK;EDkEL,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AAJJ","sourcesContent":["@import \"../../css/breakpoints.scss\";\n@import \"../../css/colors.scss\";\n.services-offered-selection {\n  .services-offered-section {\n    display: flex;\n    gap: 25px;\n    flex-wrap: wrap;\n    .section {\n      width: 100%;\n      padding: 50px 0;\n      box-sizing: border-box;\n      margin: 0 auto;\n      background-color: white;\n      display: flex;\n      flex-flow: wrap;\n      gap: 25px;\n      justify-content: space-between;\n      align-items: flex-start;\n      align-content: flex-start;\n    }\n    .input-section-label {\n      display: inline-flex;\n      align-items: flex-start;\n      color: $color15;\n      font-size: 20px;\n    }\n    .input-group {\n      width: 100%;\n      display: flex;\n      flex-flow: wrap;\n      gap: 15px;\n      label {\n        padding: 5px;\n        img {\n          width: 23px;\n        }\n      }\n      label.parent {\n        display: flex;\n        width: 48%;\n        justify-content: flex-start;\n        align-items: flex-start;\n        .label-title {\n          margin-left: 25px;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n  @media (max-width: $lg) {\n    .services-offered-section {\n      flex-direction: column;\n      .input-group {\n        label.parent {\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n\n.section-title-and-error {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  .title-name {\n    width: 100%;\n  }\n  .error {\n    color: $color6;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n  }\n}\n","$color1: #e34634;\n$color2: #d02050;\n$color3: #46b1ff;\n$color4: #f5eee7;\n$color5: #baad9e;\n$color6: #aa004f;\n$color7: #bebebe;\n$color8: #d6d6d6;\n$color9: #f8f7f7;\n$color10: #202121;\n$color11: #848484;\n$color12: #aa004f;\n$color13: #37AA1E;\n$color14: #E4E5F1;\n$color15: #CB186B;\n$color16: #FCD3CA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
